import appService from "../Network/lib/appService";

import * as actionTypes from "./appActionTypes";

const configRequestStart = () => ({
  type: actionTypes.CONFIG_REQUEST_START
});

const configRequestSuccess = (data) => ({
  type: actionTypes.CONFIG_REQUEST_SUCCESS,
  data
});

const configRequestFail = (error) => ({
  type: actionTypes.CONFIG_REQUEST_FAIL,
  error
});
const fetchModelStart = () => ({
  type: actionTypes.FETCH_MODEL_START
});
const fetchModelSuccess = (data) => ({
  type: actionTypes.FETCH_MODEL_SUCCESS,
  data
});
const fetchModelFail = (error) => ({
  type: actionTypes.FETCH_MODEL_FAIL,
  data: error
});

export const fetchUserConfig = (queryParam) => (dispatch) => {
  dispatch(configRequestStart());
  return new Promise((resolve, reject) => {
    appService
      .getConfig(queryParam)
      .then((response) => {
        dispatch(configRequestSuccess(response));
        resolve(response);
      })
      .catch((err) => {
        dispatch(configRequestFail(err.response?.data?.error));
        reject(err);
      });
  });
};
const fetchMenusStart = () => ({
  type: actionTypes.FETCH_MENU_START
});
const fetchMenuSuccess = (data) => ({
  type: actionTypes.FETCH_MENU_SUCCESS,
  data
});
const fetchMenuFail = (error) => ({
  type: actionTypes.FETCH_MENU_FAIL,
  data: error
});

export const fetchMenus = () => (dispatch) => {
  dispatch(fetchMenusStart());
  return new Promise((resolve, reject) => {
    appService
      .getMenus()
      .then((response) => {
        dispatch(fetchMenuSuccess(response));
        resolve(response);
      })
      .catch((err) => {
        dispatch(fetchMenuFail(err.response?.data?.error));
        reject(err);
      });
  });
};

export const fetchModels = (id) => (dispatch) => {
  dispatch(fetchModelStart());
  return new Promise((resolve, reject) => {
    appService
      .getModel(id)
      .then((response) => {
        dispatch(fetchModelSuccess(response));
        resolve(response);
      })
      .catch((err) => {
        dispatch(fetchModelFail(err.response?.data?.error));
        reject(err);
      });
  });
};
